import React from 'react';
import CIcon from '@coreui/icons-react';
import { useSelector } from 'react-redux';
import { UserRoles } from '../shared/models/user';
import { selectUserProfile } from '../store/selectors/profile.selectors';
import { selectAgentCount } from '../store/selectors/user.selectors';
import { selectUserOrganization } from '../store/selectors/store.selectors';
import { isInactiveSubscription } from '../shared/utils/chargebee-utils';

const WARNING_MESSAGES = {
  agentCount: {
    admin: 'Attention! # of agents exceeds # of licenses. Please go to Account & Billing to update your subscription.',
    manager: 'Attention! # of agents exceeds # of licenses. Please contact your administrator.'
  },
  subscription: {
    admin: 'There is an issue with your subscription. Please  go to Account → Account & Billing to update your subscription',
    nonAdmin: 'There is an issue with your subscription. Please  contact your Glympse Pro administrator.'
  }
};

const ErrorLayout = () => {
  const profile = useSelector(selectUserProfile);
  const org = useSelector(selectUserOrganization);
  const agentCount = useSelector(selectAgentCount);
  const maxAgents = org?.billing_subscription?.max_agents;
  const isAdmin = profile?.roles.indexOf(UserRoles.Admin) > -1;
  const isManager = profile?.roles.indexOf(UserRoles.Manager) > -1 && profile?.roles.indexOf(UserRoles.Admin) === -1;
  return (
    <>
      {
        isInactiveSubscription(org) ? (
          <div className="d-flex align-items-center text-white bg-color-red alert font-weight-bold">
            <CIcon className="text-white mr-2" name="cil-warning" />
            {
              // eslint-disable-next-line no-nested-ternary
              isAdmin ? WARNING_MESSAGES.subscription.admin : WARNING_MESSAGES.subscription.nonAdmin
            }
          </div>
        ) : null
      }
      {
        (maxAgents > 0 && agentCount > maxAgents && (isAdmin || isManager)) ? (
          <div className="d-flex align-items-center text-white bg-color-red alert font-weight-bold">
            <CIcon className="text-white mr-2" name="cil-warning" />
            {
              // eslint-disable-next-line no-nested-ternary
              isAdmin ? WARNING_MESSAGES.agentCount.admin : isManager ? WARNING_MESSAGES.agentCount.manager : null
            }
          </div>
        ) : null
      }
    </>
  );
};

export default ErrorLayout;
